/* eslint-disable @typescript-eslint/ban-types */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/indent */
/* eslint-disable @typescript-eslint/space-before-function-paren */
import './rectangle.css';
import { nanoid } from 'nanoid';
import { memo, useMemo } from 'react';

import { InnerBox, ParentBox, StaticInnerBox } from './style';
import { useAppSelector } from '../../store/hooks';
import { RootState } from '../../store';
import { useSelector } from 'react-redux';

interface RectangleProp {
  active?: boolean;
  action: Function;
  children: JSX.Element;
  hooverEffect?: boolean;
}

export const Rectangle = memo(function Rectangle(
  props: RectangleProp
): JSX.Element {
  const { active, action, children } = props;

  const { customTheme } = useSelector((state: RootState) => state.customTheme);

  const { rectangle } = customTheme;
  // const classes = useStyles()

  const innerContent = useMemo(() => {
    return <>{children}</>;
  }, [children]);

  const Content = useMemo(() => {
    return (
      <InnerBox {...rectangle} selected={active ?? false}>
        {innerContent}
      </InnerBox>
    );
  }, [innerContent, active, rectangle]);

  return (
    <ParentBox
      borderRadius={rectangle.borderRadius}
      key={nanoid()}
      onClick={() => action()}
    >
      {Content}
    </ParentBox>
  );
});

interface prop {
  children: JSX.Element;
}

export const StaticRectangle = memo(function StaticRectangle(
  props: prop
): JSX.Element {
  const { children } = props;
  const { customTheme } = useSelector((state: RootState) => state.customTheme);
  const { rectangle } = customTheme;

  return (
    <ParentBox borderRadius={rectangle.borderRadius} staticType key={nanoid()}>
      <StaticInnerBox borderWidth={rectangle.borderWidth}>
        {children}
      </StaticInnerBox>
    </ParentBox>
  );
});
